import { createAction, createSlice } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { ITraderInfo } from "../interface/ITrader";
import { RootState } from "../store/store";

import { logoutUser } from "./common";

export const resetTrader = createAction("trader/reset");

type SliceState = { value: ITraderInfo | null; status: string };

const initialState = {
  value: null,
  status: COMMON_STATUS.INITIAL,
} as SliceState;

export const traderSlice = createSlice({
  name: "trader",
  initialState,
  reducers: {
    setCurrentTrader: (state, action) => {
      state.value = action.payload;
      state.status = COMMON_STATUS.LOADED;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetTrader, (n) => {
        return initialState;
      });
  },
});

export const { setCurrentTrader } = traderSlice.actions;
export const getCurrentTrader = (state: RootState) => state.trader.value;
export const hasCurrentTrader = (state: RootState) =>
  state.trader.value != null;
export const getTradersStatus = (state: RootState) => state.trader.status;
export const getCurrentTraderAddresses = (state: RootState) =>
  state.trader.value ? state.trader.value?.addresses : [];
export const getCurrentTraderId = (state: RootState) =>
  state.trader.value ? state.trader.value.id : null;
export default traderSlice.reducer;
